import styled from "styled-components"
import { getLegalLinksForAudience } from "../constants/legal"
import { getHeaderTheme } from "../config/headerTheme"

const audienceCopy = {
  host: "He leído y acepto los",
  resto: "He leído y acepto los",
}

const tailCopy = {
  host: "y la",
  resto: "y la",
}

const LegalConsent = ({
  audience = "host",
  checked = false,
  onChange,
  disabled = false,
  hint = "",
}) => {
  const links = getLegalLinksForAudience(audience)
  const firstLink = links[0]
  const secondLink = links[1]

  return (
    <ConsentWrap>
      <ConsentLabel>
        <ConsentCheckbox
          type="checkbox"
          checked={checked}
          onChange={(event) => onChange?.(event.target.checked)}
          disabled={disabled}
        />
        <ConsentText>
          {audienceCopy[audience] || audienceCopy.host}{" "}
          <ConsentLink
            href={firstLink?.href}
            target="_blank"
            rel="noreferrer"
            onClick={(event) => event.stopPropagation()}
          >
            {firstLink?.label}
          </ConsentLink>{" "}
          {tailCopy[audience] || tailCopy.host}{" "}
          <ConsentLink
            href={secondLink?.href}
            target="_blank"
            rel="noreferrer"
            onClick={(event) => event.stopPropagation()}
          >
            {secondLink?.label}
          </ConsentLink>
          .
        </ConsentText>
      </ConsentLabel>
      {hint ? <ConsentHint>{hint}</ConsentHint> : null}
    </ConsentWrap>
  )
}

export default LegalConsent

const ConsentWrap = styled.div`
  margin-top: 18px;
  text-align: left;
`

const ConsentLabel = styled.label`
  display: flex;
  align-items: flex-start;
  gap: 10px;
  cursor: pointer;
`

const theme = getHeaderTheme();

const ConsentCheckbox = styled.input`
  margin-top: 3px;
  accent-color: ${theme.accent};
`

const ConsentText = styled.span`
  color: #374151;
  font-size: 13px;
  line-height: 1.6;
`

const ConsentLink = styled.a`
  color: ${theme.accent};
  font-weight: 600;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`

const ConsentHint = styled.p`
  margin: 8px 0 0 28px;
  color: #6b7280;
  font-size: 12px;
  line-height: 1.5;
`
